<!-- https://www.figma.com/design/K7vDg6el3Bz7MHUdlMREDj/Credit-Conversion-Statuses?node-id=2027-58&p=f&m=dev -->
<template>
  <CardLayout
    button-href="/dashboard"
    button-text="Return to dashboard"
    title="Credit status pending"
    :body="cardBody"
    :button-data-layer-event="dataLayerEvent"
    :button-disabled="isPolling"
  >
    <template #art>
      <ArtPending />
    </template>
  </CardLayout>
</template>

<script>
import CardLayout from '../ui/CardLayout.vue';
import ArtPending from './ArtPending.vue';

export default {
  name: 'CardPending',
  components: {
    CardLayout,
    ArtPending
  },
  props: {
    isPolling: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      /**
       * @type {import('../ui/card-body').CardBody}
       */
      cardBody: {
        blocks: [
          {
            lines: [
              `Your credit request is being processed. Please don't leave this screen while we are converting your transcript. This typically takes a few moments.`
            ]
          },
          {
            lines: [
              `If you have questions, please contact the support team at <a href="mailto:ulcourses@asu.edu" class="card-body-link">ulcourses@asu.edu</a>.`
            ]
          }
        ]
      }
    };
  },
  computed: {
    dataLayerEvent() {
      return {
        event: 'link',
        action: 'click',
        name: 'onclick',
        type: 'internal link',
        region: 'main content',
        section: 'credit status pending',
        text: 'return to dashboard',
        component: 'pending card'
      };
    }
  }
};
</script>
